var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_51603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.0625V14.625C15.75 15.2217 15.5129 15.794 15.091 16.216C14.669 16.6379 14.0967 16.875 13.5 16.875H9.5625",
    stroke: "#4B4AD5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9H13.5C13.2016 9 12.9155 9.11853 12.7045 9.32951C12.4935 9.54048 12.375 9.82663 12.375 10.125V12.9375C12.375 13.2359 12.4935 13.522 12.7045 13.733C12.9155 13.944 13.2016 14.0625 13.5 14.0625H15.75V9ZM15.75 9C15.75 8.11358 15.5754 7.23583 15.2362 6.41689C14.897 5.59794 14.3998 4.85382 13.773 4.22703C13.1462 3.60023 12.4021 3.10303 11.5831 2.76381C10.7642 2.42459 9.88642 2.25 9 2.25C8.11358 2.25 7.23583 2.42459 6.41689 2.76381C5.59794 3.10303 4.85382 3.60023 4.22703 4.22703C3.60023 4.85382 3.10303 5.59794 2.76381 6.41689C2.42459 7.23583 2.25 8.11358 2.25 9M2.25 9V12.9375C2.25 13.2359 2.36853 13.522 2.5795 13.733C2.79048 13.944 3.07663 14.0625 3.375 14.0625H4.5C4.79837 14.0625 5.08452 13.944 5.29549 13.733C5.50647 13.522 5.625 13.2359 5.625 12.9375V10.125C5.625 9.82663 5.50647 9.54048 5.29549 9.32951C5.08452 9.11853 4.79837 9 4.5 9H2.25Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_51603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.cd8ba97d5e4d1695c63d49cb8ecdce66.svg";
export { ForwardRef as ReactComponent };